import React from 'react';
import { MetaInfoDescription } from './MetaInfoDescription';
import ILink from '../../../../types/ILink';
import { KeywordsList } from '../../Keywords';

export function KeywordsMetaInfo({ keywords, term }: { term: string; keywords: ILink[] }) {
  return (
    <MetaInfoDescription term={term}>
      <KeywordsList keywords={keywords} />
    </MetaInfoDescription>
  );
}
